module.exports = __webpack_public_path__ + "img/logo.6d613503.svg";